import { render, staticRenderFns } from "./AnnouncementDialog.vue?vue&type=template&id=8178cfc2&scoped=true"
import script from "./AnnouncementDialog.vue?vue&type=script&lang=js"
export * from "./AnnouncementDialog.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementDialog.vue?vue&type=style&index=0&id=8178cfc2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8178cfc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8178cfc2')) {
      api.createRecord('8178cfc2', component.options)
    } else {
      api.reload('8178cfc2', component.options)
    }
    module.hot.accept("./AnnouncementDialog.vue?vue&type=template&id=8178cfc2&scoped=true", function () {
      api.rerender('8178cfc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AnnouncementDialog.vue"
export default component.exports